'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _appMenu = require('./app-menu.component');

var _appMenu2 = _interopRequireDefault(_appMenu);

require('./app-menu.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('common.app-menu', []).component('appMenu', _appMenu2.default).name;


// WEBPACK FOOTER //
// ./components/app/common/app-menu/app-menu.module.js